var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menubutton",class:{ 'menubutton-opend': _vm.isOpened },on:{"click":_vm.openNavigation}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }